import { HighLowChart } from '@design/charts/high-low-chart/HighLowChart';
import { Button } from '@design/components/button/Button';
import { ScenariosData } from '@terminal/react-query-hooks/scenarios/useScenarios';
import { ChartLegend } from '@terminal/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/earnings-event-drawer-content/earnings-chart/chart-legend/ChartLegend';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EpsExpectationsSection.module.scss';

export interface HighLowMedianDataPoint {
  high: number;
  low: number;
  median: number;
  label?: string;
  horizon?: string;
}

export interface WhatIfChartProps {
  entityName: string;
  scenariosData: ScenariosData[];
  activeButtonLabel: string;
  handleDigIntoData?: () => void;
  mappedScenariosData: HighLowMedianDataPoint[];
  width: number;
  chartHeight: number;
}

export const WhatIfChart = ({
  entityName,
  scenariosData,
  activeButtonLabel,
  handleDigIntoData,
  mappedScenariosData,
  width,
  chartHeight,
}: WhatIfChartProps) => {
  const { t } = useTranslation(['earnings', 'whatsNew']);

  return (
    <>
      <div className={styles.flexRow}>
        <div className={styles.chartTitleLabel}>
          {t(
            'earnings:earningsInsight.drawer.earningsPreview.stockPerformanceAfterEarnings',
            {
              name: entityName,
              count: scenariosData[0]?.episodes?.length,
              expectation: activeButtonLabel,
            }
          )}
        </div>
        {handleDigIntoData && (
          <Button
            className={styles.styledButton}
            label={t(
              'earnings:earningsInsight.drawer.earningsPreview.digIntoTheData'
            )}
            variant="empty"
            onClick={handleDigIntoData}
          />
        )}
      </div>
      <ChartLegend />
      <div className={styles.chartWrapper} data-testid="chart-container">
        <HighLowChart
          data={mappedScenariosData}
          width={width}
          height={chartHeight}
          variant="tertiary"
        />
      </div>
    </>
  );
};
